import React, { useState } from 'react';


function ForpassOTP() {
    const [otp, setOtp] = useState(["", "", "", ""]);

    const handleChange = (e, index) => {
        const value = e.target.value;

        if (value === "" || /^[0-9]$/.test(value)) {
            const newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);

            // Automatically focus next input when the user types a digit
            if (value !== "" && index < 3) {
                document.getElementById(`otp-input-${index + 1}`).focus();
            }
        }
    };

    const handleKeyDown = (e, index) => {
        // If Backspace is pressed and the input is empty, focus the previous input
        if (e.key === "Backspace" && otp[index] === "") {
            if (index > 0) {
                document.getElementById(`otp-input-${index - 1}`).focus();
            }
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        alert(`OTP Submitted: ${otp.join("")}`);
    };

    return (
        <div className='verify_otp'>
            <div className="verify-otp-container">
                <div className="card col-lg-6">
                    <h2 className="verify-otp-header">Verify OTP</h2>
                    <form onSubmit={handleSubmit} className="verify-otp-form">
                        <div className="row otp-inputs">
                            {otp.map((digit, index) => (
                                <div className="col-lg-3" key={index}>
                                    <input
                                        type="text"
                                        id={`otp-input-${index}`}
                                        value={digit}
                                        onChange={(e) => handleChange(e, index)}
                                        onKeyDown={(e) => handleKeyDown(e, index)} // Handle Backspace key
                                        maxLength="1"
                                        className="otp-input"
                                        autoFocus={index === 0}
                                    />
                                </div>
                            ))}
                        </div>
                        <button type="submit" className="verify-otp-button">
                            Verify OTP
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default ForpassOTP;
